import st_ai from "./AngelInfo.module.css";

const AngelInfo = () => {

    return (
        <section className={st_ai.section}>
            <div className={st_ai.container}>
                <h1 className={st_ai.title}>Who We Are</h1>
                <p className={st_ai.desc}>
                Angel Protocol enables charities to benefit from Web3 technology, community, and philanthropy.
                100% of any donations go to the charity. Always. Not just in times of crisis. Donations help build an endowment that keeps growing and giving, forever.
                <br/>
                <br/>
                Angel Protocol charges no set-up fees and no processing fees, so charities have a free way to accept cryptocurrency donations. We create endowments for charities where 10% of all yield generated is redistributed to all Angel charities and $HALO token governance contributors.
                <br/>
                <br/>
                Thanks to community efforts from contributors such as yourself, we were able to raise $1.5M for climate change with our <span><a href="http://restoreearth.io/" target="_blank">Restore Earth campaign</a></span>. Additionally, we were able to raise $500K for <span><a href="https://forum.angelprotocol.io/t/prop-1-super-typhoon-rai-disaster-relief-yellow-boat-of-hope-discussion/55" target="_blank">Typhoon Rai disaster relief efforts</a></span> in the Philippines. With your support, we can raise even more for Ukrainian refugees in need.
                <br/>
                <br/>
                By donating now, you become part of a global, community-owned charity that can respond today, and build for the future. 
                Thank you.
                </p>
            </div>
        </section>
    )
}

export default AngelInfo;